import * as React from "react";
import { forwardRef } from "react";
const SvgDoubleArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 10, viewBox: "0 0 11 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.0893 1.17918L6.26848 5L10.0893 8.82082L8.91016 10L3.91016 5L8.91016 0L10.0893 1.17918Z", fill: "#636363" }), /* @__PURE__ */ React.createElement("path", { d: "M6.17914 1.17918L2.35832 5L6.17914 8.82082L5 10L0 5L5 0L6.17914 1.17918Z", fill: "#636363" }));
const ForwardRef = forwardRef(SvgDoubleArrowLeft);
export { ForwardRef as ReactComponent };
